.List {
  display: flex;
  flex-direction: column;
  margin: 0;
  list-style: none;
  gap: var(--base-size-8);
  padding-inline-start: 0px;
  font-family: var(--brand-body-fontFamily);
  color: var(--brand-color-text-default);
}
